import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';

import { HttpClient } from '@angular/common/http';
import { Language } from 'app/core';

// add "non EN" locales
registerLocaleData(localePt, 'pt');

export type NativeSupportedLanguage = { localeCode: string; nativeName: string; selected: boolean };
export type LocaleConfig = { language: string; nativeSupportedLanguages: NativeSupportedLanguage[] };

@Injectable()
export class LocaleConfigService {
    private language: string = '';
    private LOCALE_KEY = 'bG9jYWxlQ29kZQ==';
    private nativeSupportedLanguages: NativeSupportedLanguage[] = [];

    constructor(private http: HttpClient) {}

    changeLocale(nativeLanguageName: string): void {
        for (const nativeSupportedLocale of this.nativeSupportedLanguages) {
            if (nativeSupportedLocale.nativeName === nativeLanguageName && !nativeSupportedLocale.selected) {
                this.set(nativeSupportedLocale.localeCode);
                window.location.reload();
            }
        }
    }

    getCountryPrefix(): string {
        const locale = this.get();
        return environment.supportedLocales.find((sl) => sl.localeId === locale)?.countryPrefix || 'GB';
    }

    async getLocaleConfig(localeCode: string): Promise<LocaleConfig> {
        this.language = '';
        this.nativeSupportedLanguages = [];

        const allLanguagesByLocale = await this.http.get<Language>('/assets/languages/list.json').toPromise();

        for (const supportedLocale of environment.supportedLocales) {
            this.nativeSupportedLanguages.push({
                localeCode: supportedLocale.localeId,
                nativeName: allLanguagesByLocale[supportedLocale.localeId]?.nativeName,
                selected: localeCode === supportedLocale.localeId,
            });

            if (localeCode === supportedLocale.localeId) {
                this.language = allLanguagesByLocale[supportedLocale.localeId]?.nativeName;
            }
        }

        return {
            language: this.language,
            nativeSupportedLanguages: this.nativeSupportedLanguages,
        } as LocaleConfig;
    }

    get(): string {
        const language = window.navigator.language;

        const initialState =
            language !== null && language !== ''
                ? environment.supportedLocales.map((l) => l.localeId).includes(language.substring(0, 2))
                    ? language.substring(0, 2)
                    : 'en'
                : 'en';

        // default language should be based on the browser locale, if that language isn't available it should default to english
        return localStorage.getItem(this.LOCALE_KEY) || initialState;
    }

    set(locale: string): void {
        localStorage.setItem(this.LOCALE_KEY, locale);
    }
}
